var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Info Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,22.4473068 C14.3588993,22.4473068 17.0111241,21.3495316 19.2066745,19.1539813 C21.4022248,16.9584309 22.5,14.3149883 22.5,11.2236534 C22.5,8.1323185 21.4022248,5.48887588 19.2066745,3.29332553 C17.0111241,1.09777518 14.3588993,0 11.25,0 C8.1411007,0 5.48009368,1.10655738 3.26697892,3.31967213 C1.08899297,5.49765808 0,8.1323185 0,11.2236534 C0,14.3149883 1.09777518,16.9584309 3.29332553,19.1539813 C5.48887588,21.3495316 8.1411007,22.4473068 11.25,22.4473068 Z M11.25,20.234192 C8.7734192,20.234192 6.65690867,19.3559719 4.90046838,17.5995316 C3.1440281,15.8430913 2.26580796,13.7177986 2.26580796,11.2236534 C2.26580796,8.7295082 3.1440281,6.60421546 4.90046838,4.84777518 C6.65690867,3.09133489 8.7734192,2.21311475 11.25,2.21311475 C13.7265808,2.21311475 15.8430913,3.09133489 17.5995316,4.84777518 C19.3559719,6.60421546 20.234192,8.7295082 20.234192,11.2236534 C20.234192,13.7177986 19.3559719,15.8430913 17.5995316,17.5995316 C15.8430913,19.3559719 13.7265808,20.234192 11.25,20.234192 Z M12.382904,7.85128806 L12.382904,5.58548009 L10.117096,5.58548009 L10.117096,7.85128806 L12.382904,7.85128806 Z M12.382904,16.8618267 L12.382904,10.117096 L10.117096,10.117096 L10.117096,16.8618267 L12.382904,16.8618267 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_confirmation-web-ID-3+-accts-default",
    transform: "translate(-116.000000, -251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gray-Alert-Message",
    transform: "translate(101.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Block",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-/-Atoms-/-Icons-/-Info",
    transform: "translate(14.750000, 22.306701)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uF1F7",
    fill: "#516A7B",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.348123c3a8644f095a6246f6708ff590.svg";
export { ForwardRef as ReactComponent };